import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-proposedsolution',
  templateUrl: '../view/proposedsolution.component.html',
  styleUrls: ['../view/proposedsolution.component.scss']
})
export class ProposedSolutionComponent implements OnInit {
  requestId;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.requestId = params['requestId'];
  });
  }

}
